module.exports = __webpack_public_path__ + "static/scenario-truck-select-eaab39dcb74ced1cd3a6479944ddf540.png";